import styles from "./lakimi-assistant-widget.css?raw";
import "./assistant.js";

const DEFAULT_ENDPOINT = "https://api.lakimi.io";

const bubbleTemplate = document.createElement("template");
bubbleTemplate.innerHTML = `
<style>${styles}</style>
<div class="assistant-bubble">
  <img src="./avatar.png">
</div>
<div class="modal">
  <div class="modal-content">
    <button class="modal-close">&times;</button>
    <lakimi-assistant></lakimi-assistant>
  </div>
</div>
`;

class AssistantWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(bubbleTemplate.content.cloneNode(true));
    this.initializeElements();
  }

  initializeElements() {
    this.bubbleElement = this.shadowRoot.querySelector(".assistant-bubble");
    this.modalElement = this.shadowRoot.querySelector(".modal");
    this.assistantElement = this.shadowRoot.querySelector("lakimi-assistant");
    this.closeButton = this.shadowRoot.querySelector(".modal-close");

    this.bubbleElement.addEventListener("click", () => this.toggleModal());
    this.modalElement.addEventListener("click", (event) => {
      if (event.target === this.modalElement) {
        this.toggleModal();
      }
    });
    this.closeButton.addEventListener("click", () => this.toggleModal());

    this.assistantElement.addEventListener("action", (event) =>
      this.dispatchEvent(new CustomEvent("action", { detail: event.detail }))
    );
    this.assistantElement.addEventListener("load", (event) =>
      this.dispatchEvent(new CustomEvent("load", { detail: event.detail }))
    );
  }

  get apiEndpoint() {
    return this.getAttribute("data-api-endpoint") ?? DEFAULT_ENDPOINT;
  }

  get avatarEndpoint() {
    const assistantId = this.getAttribute("data-id");
    return `${this.apiEndpoint}/assistant/avatar/${assistantId}`;
  }

  static get observedAttributes() {
    return [
      "data-id",
      "data-api-endpoint",
      "data-language",
      "data-auth-method",
      "data-environment",
      "data-client-id",
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (
      [
        "data-id",
        "data-language",
        "data-api-endpoint",
        "data-environment",
        "data-auth-method",
        "data-client-id",
      ].includes(name)
    ) {
      switch (name) {
        case "data-id":
          this.assistantElement.setAttribute("data-id", newValue);
          break;
        case "data-api-endpoint":
          this.assistantElement.setAttribute(
            "data-api-endpoint",
            newValue ?? this.apiEndpoint
          );
          break;
        case "data-language":
          this.assistantElement.setAttribute("data-language", newValue ?? "es");
          break;
        case "data-auth-method":
          this.assistantElement.setAttribute(
            "data-auth-method",
            newValue ?? "integrated"
          );
          break;
        case "data-client-id":
          this.assistantElement.setAttribute("data-client-id", newValue);
          break;
        case "data-environment":
          this.assistantElement.setAttribute(
            "data-environment",
            newValue ?? "prod"
          );
          break;
      }
    }

    if (["data-id"].includes(name)) {
      this.getAvatar();
    }
  }

  async getAvatar() {
    if (this.getAttribute("data-id") === null) {
      return;
    }

    try {
      const response = await fetch(this.avatarEndpoint);
      if (response.ok) {
        const data = await response.json();
        if (data.content) {
          const avatarElement = this.shadowRoot.querySelector(
            ".assistant-bubble img"
          );
          avatarElement.src = `data:image/png;base64,${data.content}`;
        }
      } else {
        console.error("Failed to fetch avatar:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching avatar:", error);
    }
  }

  toggleModal() {
    this.modalElement.classList.toggle("show");
  }
}

customElements.define("lakimi-assistant-widget", AssistantWidget);
